import { trimStr } from '.';

export interface DiscoveryValue {
  values: number[];
  hasYtActivity: boolean;
  ytActivity: string;
  hasSpeech: boolean;
  speech: string;
  hasOther: boolean;
  other: string;
}
export interface DiscoveryValueV3 extends DiscoveryValue {
  hasRecommend: boolean;
  recommend: string;
}

export const getDiscoveryData = (discover: DiscoveryValue) => {
  const yt = discover.hasYtActivity ? [1, discover.ytActivity] : null;
  const speech = discover.hasSpeech ? [2, discover.speech] : null;
  const other = discover.hasOther ? [5, discover.other] : null;
  return [yt, speech, other, ...discover.values].filter(Boolean);
};

export const getPostBody = (values: any, comeFrom: string) => {
  const { access_mode, activity_scale, content, discover, name, orga_name, phone, scene, title, referrer_code } =
    values;
  return {
    user_info: {
      name: trimStr(name),
      phone: `+${phone.code}${phone.phone}`,
      orga_name: trimStr(orga_name),
      title: trimStr(title),
      from_url: window.location.href,
    },
    extends_json: {
      activity_scale,
      access_mode,
      content: comeFrom === 'activity_advisory' ? [2, content] : [1, content],
      scene: scene && (scene?.hasOther ? [[10, scene.other], ...scene.checkedScenes] : [...scene.checkedScenes]),
      discover: getDiscoveryData(discover),
    },
    source: comeFrom,
    referrer_code,
  };
};

export const getDiscoveryDataV3 = (discover: DiscoveryValueV3) => {
  const yt = discover.hasYtActivity ? ['瑶台活动', discover.ytActivity] : null;
  const speech = discover.hasSpeech ? ['展会/演讲', discover.speech] : null;
  const other = discover.hasOther ? ['其他', discover.other] : null;
  const recommend = discover.hasRecommend ? ['朋友推荐', discover.recommend] : null;
  return [yt, speech, other, recommend, ...discover.values].filter(Boolean);
};
export const getPostBodyV3 = (values: any, comeFrom: string) => {
  const { access_mode, activity_scale, content, discover, name, orga_name, phone, scene, title, referrer_code } =
    values;
  return {
    user_info: {
      name: trimStr(name),
      phone: `+${phone.code}${phone.phone}`,
      orga_name: trimStr(orga_name),
      title: trimStr(title),
      from_url: window.location.href,
    },
    extends_json: {
      activity_scale,
      access_mode,
      content: comeFrom === 'activity_advisory' ? [2, content] : [1, content],
      scene: scene && (scene?.hasOther ? [[10, scene.other], ...scene.checkedScenes] : [...scene.checkedScenes]),
      discover: referrer_code ? [['朋友推荐', referrer_code]] : getDiscoveryDataV3(discover),
    },
    source: comeFrom,
    // 联系我们页面，推荐码在discover字段里
    referrer_code: discover?.hasRecommend ? discover?.recommend : referrer_code,
  };
};
